import React, { FC, ReactNode } from "react"

const colorModeKey = "color-mode"
import { darkTheme } from "../gatsby-theme-stitches/config"

type ColorMode = "light" | "dark"
type ThemeContextValue = {
  colorMode: ColorMode
  setColorMode: (newValue: ColorMode) => void
}

const themes = {
  light: "light",
  dark: darkTheme.className,
}

export const ThemeContext = React.createContext<ThemeContextValue>({
  colorMode: "light",
  setColorMode: () => {},
})

export const ThemeProvider: FC<{ children: ReactNode }> = ({ children }) => {
  const [colorMode, rawSetColorMode] = React.useState<ColorMode>("light")

  React.useEffect(() => {
    const root = document.body
    const initialColorMode = root.classList.contains(themes["dark"])
      ? "dark"
      : "light"
    rawSetColorMode(initialColorMode)
  }, [])

  const contextValue: ThemeContextValue = React.useMemo(() => {
    function setColorMode(newValue: ColorMode): void {
      document.body.classList.remove(themes[colorMode])
      document.body.classList.add(themes[newValue])
      localStorage.setItem(colorModeKey, newValue)
      rawSetColorMode(newValue)
    }

    return {
      colorMode,
      setColorMode,
    }
  }, [colorMode, rawSetColorMode])

  return (
    <ThemeContext.Provider value={contextValue}>
      {children}
    </ThemeContext.Provider>
  )
}
